import React from 'react';
import { ChevronRight } from 'lucide-react';

const Breadcrumb = ({ shop, category, product, slug, navigate, theme }) => (
  <nav className="py-4" data-testid="breadcrumb">
    <ol className="flex items-center gap-1.5 text-sm flex-wrap" style={{ color: theme.mutedText }}>
      <li>
        <button onClick={() => navigate(`/s/${slug}`)} className="hover:opacity-80 transition-opacity">
          {shop.name}
        </button>
      </li>
      {category && (
        <>
          <li><ChevronRight className="w-3.5 h-3.5" /></li>
          <li>
            <button onClick={() => navigate(`/s/${slug}`)} className="hover:opacity-80 transition-opacity">
              {category.name}
            </button>
          </li>
        </>
      )}
      <li><ChevronRight className="w-3.5 h-3.5" /></li>
      <li className="font-medium truncate max-w-[200px]" style={{ color: theme.textColor }}>{product.name}</li>
    </ol>
  </nav>
);

export default Breadcrumb;
